import IFindCaminhaoRequest from '../entities/FindCaminhaoRequest'
import IFindCaminhaoResponse from '../entities/FindCaminhaoResponse'
import { ICaminhaoRepository } from '../repositories/ICaminhaoRepository'

export interface IFindCaminhaoByPlaca {
  execute(params: IFindCaminhaoRequest): Promise<IFindCaminhaoResponse>
}

export default class FindCaminhaoByPlacaImpl implements IFindCaminhaoByPlaca {
  constructor(private readonly caminhaoRepository: ICaminhaoRepository) {}

  public async execute(
    params: IFindCaminhaoRequest,
  ): Promise<IFindCaminhaoResponse> {
    const response = await this.caminhaoRepository.findByPlaca(params)
    return response
  }
}
